// « التقويم » للمشارك — جدول الاستبيانات المفتوحة والقادمة.
export const calendar = {
  calendar_tab_label: "التقويم",
  calendar_due_before: "للإنجاز قبل {{date}}",
  calendar_opens_on: "يُفتح في {{date}}",
  calendar_next_time: "المرة القادمة: {{date}}",
  calendar_empty: "لا شيء مقرر حاليًا",
};
